import { render, staticRenderFns } from "./CustomQuestionTable.vue?vue&type=template&id=257fa871&scoped=true&"
import script from "./CustomQuestionTable.vue?vue&type=script&lang=js&"
export * from "./CustomQuestionTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomQuestionTable.vue?vue&type=style&index=0&id=257fa871&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257fa871",
  null
  
)

export default component.exports